import { api } from './client';
import type { User } from './types';

export function fetchTecnicos() {
  return api<User[]>('/users/tecnicos');
}

export function crearTecnico(payload: Record<string, unknown>) {
  return api<User>('/users/tecnico', { method: 'POST', body: JSON.stringify(payload) });
}

export function editarTecnico(id: string, data: Record<string, unknown>) {
  return api<User>(`/users/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
}

export function eliminarTecnico(id: string) {
  return api(`/users/${id}`, { method: 'DELETE' });
}

export function fetchAdmins() {
  return api<User[]>('/users/admins');
}

export function crearAdmin(payload: Record<string, unknown>) {
  return api<User>('/users/admin', { method: 'POST', body: JSON.stringify(payload) });
}

export function editarAdmin(id: string, data: Record<string, unknown>) {
  return api<User>(`/users/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
}

export function eliminarAdmin(id: string) {
  return api(`/users/${id}`, { method: 'DELETE' });
}

export function toggleDisponibilidad(id: string, disponible: boolean) {
  return api(`/users/${id}/disponibilidad`, {
    method: 'PATCH',
    body: JSON.stringify({ disponible }),
  });
}

export function cambiarPassword(currentPassword: string, newPassword: string) {
  return api('/users/password', {
    method: 'PATCH',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
}

export function editarPerfil(data: Record<string, unknown>) {
  return api<User>('/users/profile', { method: 'PATCH', body: JSON.stringify(data) });
}
